import { ScheduledSectionsQuery } from '../../../views/course_scheduler/queries/scheduled_sections_query';
import { SchedulerActiveTermQuery } from '../../queries/scheduler_active_term_query/scheduler_active_term_query';
class SchedulerActiveTerm {
  constructor(
    private ngSchedulerActiveTermQuery: SchedulerActiveTermQuery,
    private ngScheduledSectionsQuery: ScheduledSectionsQuery
  ) {}

  creditsScheduled() {
    const creditsScheduled = this.ngScheduledSectionsQuery.result.creditsScheduled;
    return creditsScheduled ? creditsScheduled : 0;
  }

  creditsRegistered() {
    const creditsRegistered = this.ngScheduledSectionsQuery.result.creditsRegistered;
    return creditsRegistered ? creditsRegistered : 0;
  }
}

angular.module('capability-ng-scheduler').component('schedulerActiveTerm', {
  templateUrl:
    'capability-ng-scheduler/src/scheduler_active_term/components/scheduler_active_term/scheduler_active_term.html',
  controller: SchedulerActiveTerm
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/scheduler_active_term/components/scheduler_active_term/scheduler_active_term.ts